interface SetSearchParamsProp {
  value: string
  key: string
  searchParams: URLSearchParams
}

interface Param {
  [key: string]: string
}

export const setCustomSearchParams = ({
  searchParams,
  value,
  key,
}: SetSearchParamsProp) => {
  const newSearchParams: Param = {}
  let isKeyInUrl = false

  for (const [previousKey, previousValue] of Array.from(searchParams)) {
    if (previousKey !== key) {
      newSearchParams[previousKey] = previousValue
    } else if (value !== '') {
      isKeyInUrl = true
      newSearchParams[key] = value
    }
  }

  if (!isKeyInUrl && value !== '') newSearchParams[key] = value

  return newSearchParams
}
